document.addEventListener("DOMContentLoaded", function (event) {
  // For :root
  let colorButton = getComputedStyle(document.documentElement)
    .getPropertyValue("--color-button")
    .trim();

  if (colorButton === "0,0,0") {
    document.documentElement.style.setProperty("--color-button", "0,0,0,0");
  }

  document.querySelectorAll("[data-section-id]").forEach((element) => {
    let colorButton = getComputedStyle(element)
      .getPropertyValue("--color-button")
      .trim();

    if (colorButton === "0,0,0") {
      element.style.setProperty("--color-button", "0,0,0,0");
    }
  });

  if (document.querySelector(".drawer__upsell-close")) {
    // document.querySelector('.drawer__upsell-close').addEventListener('click', () => {
    //   document.querySelector('.drawer__upsell').classList.add('visually-hidden');
    // });

    document
      .querySelector(".drawer")
      .addEventListener("click", function (event) {
        if (event.target.matches(".drawer__upsell-close")) {
          document
            .querySelector(".drawer__upsell")
            .classList.add("visually-hidden");
          document.querySelector(".drawer").classList.add("upsell-closed");
        }
      });
  }

  if (window.innerWidth < 1279) {
    document.querySelectorAll("footer details[open]").forEach((el) => {
      el.removeAttribute("open");
    });
  }

  // if(document.querySelector('.hero')) {
  //   if(getCookie('hero_played') === 'true') {
  //     if(window.innerWidth < 1024) {
  //       document.querySelector('.hero__content').classList.add('transition-up');

  //       setTimeout(() => {
  //         let heroContentHeight = document.querySelector('.hero__content').offsetHeight;
  //         document.querySelector('.hero').classList.add('init');
  //         document.querySelector('.header-wrapper').classList.add('transition-up');
  //         document.querySelector('.hero').classList.add('transition-up');
  //         // document.querySelector('.hero__mobile-foreground').style.bottom = `${heroContentHeight}px`;
  //         document.querySelector('body').classList.remove('locked');
  //       }, 800);

  //     } else {
  //       document.querySelector('.hero').classList.add('init');
  //       document.querySelector('.hero').classList.add('transition-up');
  //       document.querySelector('.header-wrapper').classList.add('transition-up');

  //       setTimeout(() => {
  //         document.querySelector('body').classList.remove('locked');
  //       }, 1200)
  //     }

  //   } else if(document.querySelector('.hero__shutter')) {
  //     if(window.innerWidth < 1024) {
  //       let heroContentHeight = document.querySelector('.hero__content').offsetHeight;
  //       document.querySelector('.hero__content').style.bottom = `-${heroContentHeight}px`;

  //       setTimeout(() => {
  //         document.querySelector('.hero').classList.add('init');
  //         document.querySelector('.header-wrapper').classList.add('transition-up');
  //       }, 800);

  //       setTimeout(() => {
  //         document.querySelector('.hero').classList.add('transition-up');
  //         // document.querySelector('.hero__mobile-foreground').style.bottom = `${heroContentHeight}px`;
  //         document.querySelector('body').classList.remove('locked');
  //         setCookie('hero_played', 'true', 365);
  //       }, 800);

  //     } else {
  //       setTimeout(() => {
  //         document.querySelector('.hero').classList.add('transition-up');
  //         document.querySelector('.header-wrapper').classList.add('transition-up');

  //         setTimeout(() => {
  //           document.querySelector('body').classList.remove('locked');

  //           setCookie('hero_played', 'true', 365);
  //         }, 1200)
  //       }, 3000);
  //     }
  //   }
  // }

  // if(document.querySelector('.hero__shutter')) {
  //   setTimeout(() => {
  //     document.querySelector('.hero').classList.add('animated');
  //     document.querySelector('.header-wrapper').classList.add('animated');

  //     setTimeout(() => {
  //       document.querySelector('body').classList.remove('locked');
  //     }, 1200)
  //   }, 3000);
  // }

  if (document.querySelector(".nav__stages")) {
    document.querySelectorAll(".nav__stages .parent-icon").forEach((el) => {
      el.addEventListener("click", (e) => {
        e.preventDefault();
        e.target.closest(".nav__stages").classList.toggle("view-children");
        e.target.closest(".nav__stages-parent").classList.add("active");
      });
    });

    document
      .querySelectorAll(".nav__stages svg.children-icon")
      .forEach((el) => {
        el.addEventListener("click", (e) => {
          e.preventDefault();
          e.target
            .closest(".nav__stages")
            .classList.toggle("view-grand-children");
        });
      });

    document.querySelectorAll(".nav__stages-return").forEach((el) => {
      el.addEventListener("click", (e) => {
        e.preventDefault();

        if (
          e.target
            .closest(".nav__stages")
            .classList.contains("view-grand-children")
        ) {
          e.target
            .closest(".nav__stages")
            .classList.remove("view-grand-children");
        } else {
          e.target.closest(".nav__stages").classList.remove("view-children");
          setTimeout(() => {
            document
              .querySelector(".nav__stages-parent.active")
              .classList.remove("active");
          }, 400);
        }
      });
    });
  }

  // if(document.querySelector('.certification-overlay.default-expanded')) {
  //   setTimeout(() => {
  //     if(getCookie('cert-closed') !== 'true') {
  //       document.querySelector('.certification-overlay').classList.add('active');
  //     }
  //   }, getCookie('hero_played') === 'true' ? 3000 : 6000);
  // }

  if (document.querySelector(".steps")) {
    const stepsSlider = new Swiper(".steps .swiper", {
      slidesPerView: 1,
      allowTouchMove: false,
      loop: true,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      autoplay: {
        delay: 4000,
      },
    });

    stepsSlider.on("slideChange", function () {
      if (document.querySelector(".steps__nav div.active")) {
        document
          .querySelector(".steps__nav div.active")
          .classList.remove("active");
      }
      document
        .querySelector(`.steps__nav div[data-index="${stepsSlider.realIndex}"]`)
        .classList.add("active");
    });

    document.querySelectorAll(".steps__nav-item").forEach((el) => {
      el.addEventListener("click", (e) => {
        e.preventDefault();
        stepsSlider.slideTo(e.target.dataset.index);
      });
    });
  }

  if (document.querySelector(".cart__featured-products__products")) {
    const featuredProductsSlider = new Swiper(
      ".cart__featured-products__products.swiper",
      {
        slidesPerView: 1,
        spaceBetween: 15,
        autoHeight: true,
        autoplay: {
          delay: 4000,
        },
        navigation: {
          prevEl: ".cart__featured-products .arrow-left",
          nextEl: ".cart__featured-products .arrow-right",
        },
        breakpoints: {
          1024: {
            slidesPerView: 2,
            spaceBetween: 15,
          },
          1680: {
            slidesPerView: 3,
            spaceBetween: 15,
          },
        },
      }
    );
  }

  if (document.querySelector(".hero-slider.swiper")) {
    const autoplay =
      document.querySelector(".hero-slider.swiper").dataset.autoplay === "true"
        ? true
        : false;
    const autoplaySpeed = document.querySelector(".hero-slider.swiper").dataset
      .autoplaySpeed
      ? parseInt(
          document.querySelector(".hero-slider.swiper").dataset.autoplaySpeed
        )
      : 4000;
    const heroSlider = new Swiper(".hero-slider.swiper", {
      effect: "fade",
      loop: true,
      allowTouchMove: false,
      autoplay: autoplay
        ? {
            delay: autoplaySpeed * 1000,
          }
        : false,
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        prevEl: ".hero .arrow-left",
        nextEl: ".hero .arrow-right",
      },
    });
  }

  if (document.querySelector(".product-slider")) {
    const productSlider = new Swiper(".product-slider", {
      slidesPerView: 2.18,
      loop: true,
      spaceBetween: 15,
      navigation: {
        prevEl: ".collection .arrow-left",
        nextEl: ".collection .arrow-right",
      },
      breakpoints: {
        1024: {
          slidesPerView: 2.2,
          spaceBetween: 15,
        },
        1280: {
          slidesPerView: 3.4,
          spaceBetween: 15,
        },
      },
    });
  }

  if (document.querySelector(".blog__posts .swiper")) {
    let arrows = {
      prevEl: ".blog .arrow-left--mobile",
      nextEl: ".blog .arrow-right--mobile",
    };
    if (window.innerWidth > 1024) {
      arrows = { prevEl: ".blog .arrow-left", nextEl: ".blog .arrow-right" };
    }
    const blogSlider = new Swiper(".blog__posts .swiper", {
      slidesPerView: 1.5,
      spaceBetween: 10,
      navigation: {
        prevEl: arrows.prevEl,
        nextEl: arrows.nextEl,
      },
      breakpoints: {
        1024: {
          slidesPerView: 2.2,
          spaceBetween: 15,
        },
        1280: {
          slidesPerView: 3.2,
          spaceBetween: 15,
        },
      },
    });
  }

  const imageWithTexts = document.querySelectorAll(".image-with-text");
  if (imageWithTexts.length) {
    imageWithTexts.forEach((el) => {
      const textSlider = new Swiper(
        el.querySelector(".swiper.image-with-text__text"),
        {
          effect: "fade",
          allowTouchMove: false,
          fadeEffect: {
            crossFade: true,
          },
        }
      );

      const imagesSlider = new Swiper(
        el.querySelector(".swiper.image-with-text__images"),
        {
          effect: "fade",
          allowTouchMove: false,
          autoHeight: window.innerWidth >= 1024 ? false : true,
          observer: true,
          observeParents: true,
          fadeEffect: {
            crossFade: true,
          },
        }
      );

      const playActiveSlideVideo = () => {
        el.querySelectorAll(".swiper.image-with-text__images video").forEach((v) => v.pause());
        const activeSlide = el.querySelector(".swiper.image-with-text__images .swiper-slide-active");
        const activeVideo = activeSlide?.querySelector("video");
        if (activeVideo) activeVideo.play().catch(() => {});
      };

      imagesSlider.on("slideChangeTransitionEnd", playActiveSlideVideo);

      const firstSlide = el.querySelector(".swiper.image-with-text__images .swiper-slide-active");
      const firstVideo = firstSlide?.querySelector("video");
      if (firstVideo?.autoplay) firstVideo.play().catch(() => {});

      el.querySelectorAll(".image-with-text__nav span").forEach((span) => {
        span.addEventListener("click", (e) => {
          const index = e.target.dataset.index;

          el.querySelector(
            ".image-with-text__nav span.active"
          ).classList.remove("active");
          e.target.classList.add("active");

          textSlider.slideTo(index);
          imagesSlider.slideTo(index);
        });
      });
    });
  }

  const contentScroller = document.querySelectorAll(".content-scroller");
  if (contentScroller) {
    // Select all links with hashes
    var links = document.querySelectorAll('a[href*="#"]');

    links.forEach(function (link) {
      // Remove links that don't actually link to anything
      if (
        link.getAttribute("href") !== "#" &&
        link.getAttribute("href") !== "#0"
      ) {
        link.addEventListener("click", function (event) {
          var headerHeight = document.querySelector(
            "#site-sticky-header"
          ).offsetHeight;

          document
            .querySelectorAll(".content-scroller__navlink.active")
            .forEach((el) => {
              el.classList.remove("active");
            });

          event.target.classList.add("active");
          // On-page links
          if (
            location.pathname.replace(/^\//, "") ===
              this.pathname.replace(/^\//, "") &&
            location.hostname === this.hostname
          ) {
            // Figure out element to scroll to
            var target = document.getElementById(this.hash);

            target = target
              ? target
              : document.querySelector("[name=" + this.hash.slice(1) + "]");
            // Does a scroll target exist?
            if (target) {
              // Only prevent default if animation is actually gonna happen
              event.preventDefault();
              var targetOffsetTop = target.offsetTop - headerHeight;
              var duration = 1000;
              var start = window.pageYOffset;
              var startTime =
                "now" in window.performance
                  ? performance.now()
                  : new Date().getTime();
              var scroll = function (timestamp) {
                var currentTime = timestamp || new Date().getTime();
                var elapsed = currentTime - startTime;
                var easing = function (t) {
                  return t < 0.5
                    ? 4 * t * t * t
                    : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
                };
                window.scrollTo(
                  0,
                  Math.floor(
                    easing(elapsed / duration) * (targetOffsetTop - start) +
                      start
                  )
                );
                if (elapsed < duration) {
                  requestAnimationFrame(scroll);
                } else {
                  // Callback after animation
                  // Must change focus!
                  target.focus();
                  if (target === document.activeElement) {
                    // Checking if the target was focused
                    return false;
                  } else {
                    target.setAttribute("tabindex", "-1"); // Adding tabindex for elements not focusable
                    target.focus(); // Set focus again
                  }
                }
              };
              requestAnimationFrame(scroll);
            }
          }
        });
      }
    });
  }

  const accordionSections = document.querySelectorAll(
    ".accordion[data-section-id]"
  );

  accordionSections.forEach(function (section) {
    const accordionLabels = section.querySelectorAll(
      ".accordion__accordion-label"
    );

    if (accordionLabels.length) {
      const accordionSwiper = new Swiper(
        section.querySelector(".accordion__images.swiper"),
        {
          effect: "fade",
          allowTouchMove: false,
          fadeEffect: {
            crossFade: true,
          },
        }
      );

      let getAccordionContentHeight = (el) => {
        let accordionContentHeight = 0;

        if (window.innerWidth >= 1024) {
          const headerHeight = document.querySelector(".header").offsetHeight;
          const accordionLabel = section.querySelector(
            ".accordion__accordion-item.active .accordion__accordion-label"
          );
          accordionContentHeight =
            window.innerHeight -
            accordionLabel.offsetHeight -
            headerHeight * accordionLabels.length;
        } else {
          accordionContentHeight = el.querySelector(".text").offsetHeight;
        }

        return accordionContentHeight;
      };

      accordionLabels.forEach((el) => {
        const accordionItem = el.parentElement;

        el.addEventListener("click", (e) => {
          const index = el.dataset.index - 1;
          const accordionContent = el.nextElementSibling;
          const accordionContentHeight =
            getAccordionContentHeight(accordionContent);

          accordionSwiper.slideTo(index);

          section.querySelector(
            ".accordion__accordion-item.active .accordion__accordion-content"
          ).style.height = 0;
          section
            .querySelector(".accordion__accordion-item.active")
            .classList.remove("active");

          accordionItem.classList.add("active");
          accordionContent.style.height = accordionContentHeight + "px";
        });
      });

      window.addEventListener("resize", () => {
        const accordionContentHeight = getAccordionContentHeight(
          section.querySelector(
            ".accordion__accordion-item.active .accordion__accordion-content"
          )
        );
        section.querySelector(
          ".accordion__accordion-item.active .accordion__accordion-content"
        ).style.height = accordionContentHeight + "px";
      });

      const accordionContentHeight = getAccordionContentHeight(
        section.querySelector(
          ".accordion__accordion-item.active .accordion__accordion-content"
        )
      );
      section.querySelector(
        ".accordion__accordion-item.active .accordion__accordion-content"
      ).style.height = accordionContentHeight + "px";
    }
  });

  const singleImageVideos = document.querySelectorAll(
    ".single-image-video video, .assembly-instructions__section__video-container video"
  );

  if (singleImageVideos.length) {
    singleImageVideos.forEach((el) => {
      const video = el;
      const playButton = el.nextElementSibling;

      if (video?.autoplay) {
        // Keep muted autoplay reliable across Safari/iOS.
        video.muted = true;
        video.defaultMuted = true;
        video.setAttribute("muted", "muted");

        const attemptAutoplay = () => {
          const playPromise = video.play();
          if (playPromise?.catch) playPromise.catch(() => {});
        };

        if (video.readyState >= 2) {
          attemptAutoplay();
        } else {
          video.addEventListener("loadeddata", attemptAutoplay, { once: true });
        }
      }

      if (video && playButton) {
        [video, playButton].forEach((el) =>
          el.addEventListener("click", () => {
            if (video.paused) {
              const playPromise = video.play();

              playPromise.then(() => {
                playButton.classList.add("active");
                video.setAttribute("controls", "controls");
              });
            } else {
              video.pause();
              playButton.classList.remove("active");
              video.removeAttribute("controls");
            }
          })
        );
      }
    });
  }

  const videoSlides = document.querySelectorAll(".product__video-slide video");

  videoSlides.forEach((el) => {
    const video = el;
    const playButton = el.nextElementSibling;

    if (video) {
      [video, playButton].forEach((e) =>
        e.addEventListener("click", () => {
          if (video.paused) {
            playButton.classList.add("loading");

            const playPromise = video.play();

            playPromise.then(() => {
              playButton.classList.remove("loading");
              playButton.classList.add("active");
            });
          } else {
            video.pause();
            playButton.classList.remove("active");
          }
        })
      );
    }
  });

  const smallAccordionItems = document.querySelectorAll(".accordion-item");

  if (smallAccordionItems.length) {
    smallAccordionItems.forEach((el) => {
      el.addEventListener("click", () => {
        const contentHeight = el.querySelector(
          ".accordion-item__content .wrap"
        ).offsetHeight;

        if (el.classList.contains("active")) {
          el.querySelector(".accordion-item__content").style.maxHeight = 0;
          el.classList.remove("active");
        } else {
          const parent = el.parentElement;

          parent
            .querySelectorAll(".accordion-item.active")
            .forEach((activeEl) => {
              activeEl.querySelector(
                ".accordion-item__content"
              ).style.maxHeight = 0;
              activeEl.classList.remove("active");
            });

          el.querySelector(".accordion-item__content").style.maxHeight =
            contentHeight + "px";
          el.classList.add("active");
        }
      });
    });
  }

  const featuredProductSlider = document.querySelectorAll(".featured-products");

  if (featuredProductSlider) {
    featuredProductSlider.forEach((el) => {
      const featuredProductSliderEl = el.querySelector(".swiper");

      const swiper = new Swiper(featuredProductSliderEl, {
        slidesPerView: 1,
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 15,
          },
          1024: {
            slidesPerView: featuredProductSliderEl.dataset.rowSize,
            spaceBetween: 15,
          },
        },
      });
    });
  }

  const videoCarousels = document.querySelectorAll(".video-carousel");

  if (videoCarousels.length) {
    videoCarousels.forEach((el) => {
      const swiper = new Swiper(el.querySelector(".swiper"), {
        slidesPerView: 1,
        allowTouchMove: false,
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
      });

      el.querySelectorAll(".video-carousel__nav-label").forEach((childEl) => {
        childEl.addEventListener("click", () => {
          document
            .querySelector(".video-carousel__nav-label.active")
            .classList.remove("active");
          childEl.classList.add("active");
          // pause current video
          const prevSlide = swiper.slides[swiper.activeIndex];
          const prevVideo = prevSlide.querySelector("video");

          if (prevVideo) {
            prevVideo.pause();
            prevVideo.currentTime = 0;
          }

          swiper.slideTo(childEl.dataset.index);

          const activeSlide = swiper.slides[swiper.activeIndex];
          const currentVideo = activeSlide.querySelector("video");

          if (currentVideo) {
            currentVideo.play();
          }
        });
      });
    });
  }

  const columnSliders = document.querySelectorAll(
    ".three-column-content.slider"
  );

  if (columnSliders.length) {
    columnSliders.forEach((el) => {
      const swiper = new Swiper(el.querySelector(".swiper"), {
        slidesPerView: 1,
        breakpoints: {
          1024: {
            slidesPerView: 2.2,
            spaceBetween: 15,
          },
          1280: {
            slidesPerView: 3.2,
            spaceBetween: 15,
          },
          1680: {
            slidesPerView: 3.5,
            spaceBetween: 15,
          },
        },
        navigation: {
          prevEl: el.querySelector(".arrow-left"),
          nextEl: el.querySelector(".arrow-right"),
        },
      });
    });
  }

  const featuredBlogsSliders = document.querySelectorAll(".featured-articles");

  if (featuredBlogsSliders.length) {
    featuredBlogsSliders.forEach((el) => {
      const swiper = new Swiper(el.querySelector(".swiper"), {
        slidesPerView: 1,
        breakpoints: {
          1024: {
            slidesPerView: 2.2,
            spaceBetween: 15,
          },
          1280: {
            slidesPerView: 3.2,
            spaceBetween: 15,
          },
          1680: {
            slidesPerView: 3.5,
            spaceBetween: 15,
          },
        },
        navigation: {
          prevEl: el.querySelector(".arrow-left"),
          nextEl: el.querySelector(".arrow-right"),
        },
      });
    });
  }

  const reviewsFeedSliders = document.querySelectorAll(".reviews-feed");

  if (reviewsFeedSliders.length) {
    reviewsFeedSliders.forEach((el) => {
      const spaceBetween = {
        mobile: parseInt(el.dataset.spaceBetween),
        desktop: parseInt(el.dataset.spaceBetweenDesktop),
      };

      const swiper = new Swiper(el.querySelector(".swiper"), {
        slidesPerView: 1.07,
        spaceBetween: spaceBetween.mobile,
        breakpoints: {
          768: {
            slidesPerView: 2.2,
            slidesPerView: 2.2,
            spaceBetween: spaceBetween.desktop,
          },
          1280: {
            slidesPerView: 3.2,
            spaceBetween: spaceBetween.desktop,
          },
          1680: {
            slidesPerView: 3.5,
            spaceBetween: spaceBetween.desktop,
          },
        },
        navigation: {
          prevEl: el.querySelector(".arrow-left"),
          nextEl: el.querySelector(".arrow-right"),
        },
      });

      handleSlideState(el);

      swiper.on("slideChangeTransitionEnd", () => {
        handleSlideState(el);
      });
    });

    function handleSlideState(el) {
      const slides = el.querySelectorAll(".swiper-slide");

      slides.forEach((slide) => {
        const slideLeft = slide.getBoundingClientRect().left;
        const slideWidth = slide.offsetWidth;
        const slideRight = Math.floor(slideLeft + slideWidth);

        if (slideRight <= window.innerWidth) {
          slide.classList.remove("not-in-view");
        } else {
          slide.classList.add("not-in-view");
        }
      });
    }
  }

  const testimonialsSlider = document.querySelectorAll(".testimonials");

  if (testimonialsSlider.length) {
    testimonialsSlider.forEach((el) => {
      const settings = {
        speed: 700,
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        slidesPerView: 1,
        allowTouchMove: false,
        navigation: {
          prevEl: el.querySelector(".arrow-left"),
          nextEl: el.querySelector(".arrow-right"),
        },
      };
      const imagesSwiper = new Swiper(
        el.querySelector(".testimonials__images .swiper"),
        settings
      );

      const quotesSwiper = new Swiper(
        el.querySelector(".testimonials__quotes .swiper"),
        settings
      );

      // document.querySelectorAll('.testimonials__nav-arrows svg').forEach((el) => el.addEventListener('click', () => {
      //   if(el.classList.contains('arrow-left')) {
      //     imagesSwiper.slidePrev();
      //     quotesSwiper.slidePrev();
      //   } else {
      //     quotesSwiper.slideNext();
      //     imagesSwiper.slideNext();
      //   }
      // }))
    });
  }

  const productMapSlider = document.querySelectorAll(".product-map");

  if (productMapSlider.length) {
    productMapSlider.forEach((el) => {
      const swiper = new Swiper(el.querySelector(".swiper"), {
        slidesPerView: 1,
        allowTouchMove: false,
        speed: 700,
        effect: "fade",
        autoHeight: true,
        fadeEffect: {
          crossFade: true,
        },
      });

      const hotspots = el.querySelectorAll(".product-map__map-hotspot");

      hotspots.forEach((el) => {
        el.addEventListener("click", () => {
          const id = el.dataset.id;
          swiper.slideTo(id);

          document
            .querySelector(".product-map__map-hotspot.active")
            .classList.remove("active");
          el.classList.add("active");
        });
      });
    });
  }

  const blogFeedSlider = document.querySelectorAll(".blog-feed");

  if (blogFeedSlider.length) {
    blogFeedSlider.forEach((el) => {
      // const swiper = new Swiper(el.querySelector('.swiper'), {
      //   slidesPerView: 1,
      //   allowTouchMove: false,
      //   speed: 700,
      //   effect: 'fade',
      //   fadeEffect: {
      //     crossFade: true
      //   },
      // });

      // const categories = el.querySelectorAll('.blog-feed__categories span');
      const viewMoreBtn = el.querySelector(".blog-feed__button");

      viewMoreBtn.addEventListener("click", () => {
        const unactiveArticles = el.querySelectorAll(
          ".blog-feed__article:not(.active)"
        );

        unactiveArticles.forEach((el) => {
          el.classList.add("active");
        });

        viewMoreBtn.classList.add("hidden");
      });

      // categories.forEach((cat) => {
      //   cat.addEventListener('click', () => {
      //     const id = cat.dataset.id;
      //     const slide = el.querySelector(`.swiper-slide[data-id="${id}"]`);
      //     const articles = el.querySelectorAll(`.blog-feed__article[data-id="${id}"]`);

      //     if(slide) {
      //       swiper.slideTo(slide.dataset.index);
      //     }

      //     document.querySelector('.blog-feed__categories span.active').classList.remove('active');
      //     const prevActiveArticles = document.querySelectorAll('.blog-feed__article.active');
      //     const prevhiddenArticles = document.querySelectorAll('.blog-feed__article.hidden');

      //     if(prevActiveArticles) {
      //       prevActiveArticles.forEach((el) => {
      //         el.classList.remove('active');
      //       });
      //     }

      //     if(prevhiddenArticles) {
      //       prevhiddenArticles.forEach((el) => {
      //         el.classList.remove('hidden');
      //       });
      //     }

      //     cat.classList.add('active');

      //     if(articles) {
      //       articles.forEach((el, i) => {
      //         el.classList.add('active');
      //         if (i > 5) {
      //           el.classList.add('hidden');
      //         }

      //         el.classList.add('active');
      //       });

      //       if(articles.length < 5) {
      //         viewMoreBtn.classList.add('hidden');
      //       } else {
      //         viewMoreBtn.classList.remove('hidden');
      //       }
      //     }
      //   })
      // });
    });
  }

  if (document.querySelector(".footer__scroll-up")) {
    document
      .querySelector(".footer__scroll-up")
      .addEventListener("click", () => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      });
  }

  let navImages;

  if (document.querySelector(".nav__links.children")) {
    // const swiper = new Swiper('.nav__links.children .swiper', {
    //   slidesPerView: 1,
    //   allowTouchMove: false,
    //   speed: 300,
    //   effect: 'fade',
    //   fadeEffect: {
    //     crossFade: true
    //   },
    // });

    document
      .querySelectorAll(".nav__links.parents span,.nav__links.parents a")
      .forEach((el) => {
        el.addEventListener("mouseover", () => {
          const id = el.dataset.id;

          document
            .querySelector(".nav__links.children li.t-one.active")
            ?.classList.remove("active");
          document
            .querySelector(`.nav__links.children li[data-id="${id}"].t-one`)
            .classList.add("active");
          document
            .querySelector(".nav__links.parents a.active")
            ?.classList.remove("active");

          el.classList.add("active");
          document.querySelector(".nav__images").classList.add("active");
        });
      });
  }

  if (document.querySelector(".nav__images .swiper")) {
    navImages = new Swiper(".nav__images .swiper", {
      slidesPerView: 1,
      allowTouchMove: false,
      speed: 300,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
    });

    document.querySelectorAll(".nav a[data-id]").forEach((el) => {
      el.addEventListener("mouseover", () => {
        const id = el.dataset.id;
        const slide = document.querySelector(
          `.nav__images .swiper-slide[data-id="${id}"]`
        );
        // get the slide's index based on it's position in the parent
        const index = Array.from(slide.parentNode.children).indexOf(slide);

        navImages.slideTo(index);
      });
    });
  }

  if (document.querySelectorAll(".header__menu").length) {
    document.querySelectorAll(".header__menu").forEach((menu) =>
      menu.addEventListener("click", () => {
        document.querySelector(".nav").classList.add("active");
        document.querySelector(".nav__images").classList.add("active");
      })
    );
  }

  if (document.querySelector(".header__close")) {
    document.querySelector(".header__close").addEventListener("click", () => {
      document.querySelector(".nav").classList.remove("active");
      document.querySelector(".nav__images").classList.remove("active");
    });
  }

  if (document.querySelector(".certification-overlay")) {
    document
      .querySelector(".certification-overlay")
      .addEventListener("click", (e) => {
        if (!e.target.closest(".icon-close")) {
          let activeOffset = document.querySelector(
            ".certification-overlay"
          ).offsetWidth;
          document
            .querySelector(".certification-overlay")
            .classList.add("active");

          setTimeout(() => {
            if (window.innerWidth >= 1024) {
              // document.querySelector('.certification-overlay').style.left = `calc(100% - ${activeOffset}px)`;
            }
          }, 100);
        }
      });

    document
      .querySelector(".certification-overlay .icon-close")
      .addEventListener("click", () => {
        let unactiveOffset = 110;

        if (window.innerWidth < 1024) {
          unactiveOffset = 80;
        }

        document
          .querySelector(".certification-overlay")
          .classList.remove("active");

        if (window.innerWidth >= 1024) {
          // document.querySelector('.certification-overlay').style.left = `calc(100% - ${unactiveOffset}px)`;
        }

        setCookie("cert-closed", "true", 180);
      });
  }

  document.addEventListener("click", (e) => {
    if (!e.target.closest(".nav") && !e.target.closest(".header__menu")) {
      document.querySelector(".nav").classList.remove("active");
      document.querySelector(".nav__images").classList.remove("active");
    }
  });

  const cardModalButtons = document.querySelectorAll(
    ".cart__featured-products modal-opener button"
  );

  if (cardModalButtons.length) {
    cardModalButtons.forEach((el) => {
      el.addEventListener("click", (e) => {
        e.preventDefault();
      });
    });
  }

  const variantPickerInputs = document.querySelectorAll(
    ".variant-picker input"
  );

  if (variantPickerInputs.length) {
    variantPickerInputs.forEach((el) => {
      el.addEventListener("change", (e) => {
        const selectedValue = el
          .closest(".variant-picker")
          .querySelector(".variant-picker__current-value");

        if (selectedValue) selectedValue.innerHTML = e.target.value;
      });
    });
  }

  // Colour variants selector
  if (document.querySelectorAll(".colour-variants input").length) {
    document.querySelectorAll(".colour-variants input").forEach((el) => {
      el.addEventListener("change", (e) => {
        const variantText = document.querySelector(".selected-colour");

        variantText.innerHTML = e.target.value;
      });
    });
  }

  const gridOptions = document.querySelectorAll(".product-form__input.grid");

  if (gridOptions.length) {
    gridOptions.forEach((grid) => {
      grid.querySelectorAll(".grid-dropdown input").forEach((el) => {
        el.addEventListener("change", (e) => {
          const variantText = grid.querySelector(".selected-size span");

          variantText.innerHTML = e.target.value;
        });
      });
    });
  }

  if (document.querySelectorAll(".grid-dropdown input").length) {
  }

  if (document.querySelector(".page-navigation")) {
    const bar = document.querySelector(".page-navigation");
    const helpButton = document.querySelector(".help-button");
    const links = document.querySelectorAll(".page-navigation__links a");
    const isEclipse = bar.classList.contains("eva-custom-page-navigation");

    window.addEventListener("scroll", () => {
      if(isEclipse){
        if (!bar.classList.contains("page-navigation--product")) return;

        const sectionStart = document.querySelector(".single-image-video");
        const sectionEnd = document.querySelector(".small-accordion");
        const startRect = sectionStart.getBoundingClientRect();
        const endRect = sectionEnd.getBoundingClientRect();
        const viewportHeight = window.innerHeight;

        const afterStart = startRect.top < viewportHeight;
        const beforeEnd = endRect.top > 0;

        if (afterStart && beforeEnd) {
          bar.classList.add("active");
          if (helpButton) helpButton.classList.add("help-button--navigation-shown");
        } else {
          bar.classList.remove("active");
          if (helpButton) helpButton.classList.remove("help-button--navigation-shown");
        }
      }else{
        if (bar.classList.contains("page-navigation--product")) {
          const productFormTop = document
            .querySelector(".product .product-form")
            .getBoundingClientRect().top;
          const bodyBottom = document.body.getBoundingClientRect().bottom;
  
          if (productFormTop < 0 && bodyBottom) {
            bar.classList.add("active");
  
            if (helpButton)
              helpButton.classList.add("help-button--navigation-shown");
          } else {
            bar.classList.remove("active");
  
            if (helpButton)
              helpButton.classList.remove("help-button--navigation-shown");
          }
        } else {
          if (window.scrollY > window.innerHeight) {
            bar.classList.add("active");
  
            if (helpButton)
              helpButton.classList.add("help-button--navigation-shown");
          } else {
            bar.classList.remove("active");
  
            if (helpButton)
              helpButton.classList.add("help-button--navigation-shown");
          }
        }
      }
    });

  // Keep your smooth scroll navigation
  links.forEach((el) => {
    el.addEventListener("click", (e) => {
      e.preventDefault();
      const id = el.getAttribute("href");
      const target = document.querySelector(`[data-section-id="${id.replace("#", "")}"]`);
      const reviewtarget = document.querySelector(id);
      let scrollTargetPos = 0;
      if (target) {
        scrollTargetPos = target.getBoundingClientRect().top + window.pageYOffset - 100;
      } else if (reviewtarget) {
        scrollTargetPos = reviewtarget.getBoundingClientRect().top + window.pageYOffset - 100;
      }
      window.scrollTo({
        top: scrollTargetPos,
        behavior: "smooth",
      });
    });
  });

    const sections = gsap.utils.toArray('div[data-section-id], #reviews');
    sections.forEach((el) => {
      ScrollTrigger.create({
        trigger: el,
        start: "top top+=50%",
        end: "bottom top+=50%",
        onEnter: () => {
          let id = el.dataset.sectionId;
          if(!id){
            id=el.id;
          }
          document
            .querySelectorAll(".page-navigation__links a.active")
            .forEach((link) => link.classList.remove("active"));
          const activeLink = document.querySelector(
            `.page-navigation__links a[href="#${id}"]`
          );
          if (activeLink) {
            activeLink.classList.add("active");
          }
        },
        onLeaveBack: () => {
          const index = Math.max(sections.indexOf(el) - 1, 0);
          let id = sections[index].dataset.sectionId;
          if(!id){
            id=sections[index].id;
          }
          document
            .querySelectorAll(".page-navigation__links a.active")
            .forEach((link) => link.classList.remove("active"));
          const activeLink = document.querySelector(
            `.page-navigation__links a[href="#${id}"]`
          );
          if (activeLink) {
            activeLink.classList.add("active");
          }
        },
      });
    });
  }

  if (document.querySelector(".sandwich-accordion")) {
    window.addEventListener("scroll", () => {
      const offset = window.innerHeight * 0.65;
      const accordionElement = document.querySelector(".sandwich-accordion");
      const elementRect = accordionElement.getBoundingClientRect();

      const viewportBottom = window.innerHeight - offset;
      const elementTop = elementRect.top;

      if (elementTop <= viewportBottom) {
        accordionElement.classList.add("expand");
      } else {
        accordionElement.classList.remove("expand");
      }
    });

    let prevIndex = -1;
    document
      .querySelectorAll(".sandwich-accordion .accordion-item")
      .forEach((el) => {
        el.addEventListener("click", (e) => {
          if (window.innerWidth >= 1024) return;

          const index = e.currentTarget.dataset.index;
          const element = document.querySelector(".sandwich-accordion");
          const layoutClass = Array.from(element.classList).find((cls) =>
            cls.startsWith("layer-")
          );

          if (layoutClass) {
            element.classList.remove(layoutClass);

            if (prevIndex === index) {
              element.classList.add(`layer-`);
              prevIndex = -1;
            } else {
              element.classList.add(`layer-${index}`);
              prevIndex = index;
            }
          }
        });
      });
  }

  if (document.querySelector(".section-header")) {
    const header = document.querySelector(".section-header");
    const headerHeight = header.offsetHeight;
    const threshold = headerHeight + header.offsetTop;

    let lastScroll = 0;

    window.addEventListener("scroll", () => {
      const currentScroll = window.scrollY;

      if (currentScroll >= lastScroll && currentScroll > threshold)
        header.classList.add("section-header--hidden");
      else header.classList.remove("section-header--hidden");

      lastScroll = currentScroll;
    });
  }

  // #1378 [A/B Test] Continue Shopping Vs Bestsellers
  if (location.pathname.indexOf("/products/") > -1) {
    const maxRecords = 6;
    const productHandle = /[^/]*$/.exec(location.pathname)[0];

    const key = "recentlyViewedProducts";
    const recentlyViewedProducts = localStorage.getItem(key);
    if (!recentlyViewedProducts) {
      localStorage[key] = JSON.stringify([productHandle]);
      return;
    }

    let newList = JSON.parse(recentlyViewedProducts);
    newList = [productHandle, ...newList.filter((x) => x !== productHandle)];
    newList.length = maxRecords;
    localStorage[key] = JSON.stringify(newList);
  }
});

window.addEventListener("beforeunload", () => {
  if (document.querySelector("body.template-index")) {
    window.scrollTo(0, 0);
  }
});

function setCookie(name, value, days) {
  let expires = "";
  if (days) {
    let date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
  let nameEQ = name + "=";
  let ca = document.cookie.split(";");

  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }

  return null;
}

function eatCookie(name) {
  setCookie(name, "", -1);
}

document
  .querySelectorAll('input[name="Size"][value="Ottoman"]')
  .forEach((ottomanSelector) => {
    ottomanSelector.addEventListener("click", () => {
      const armType = document.querySelector(
        'input[name="Arm Type"][value="Low"]'
      );

      if (!armType || armType.checked) return;
      else {
        armType.click();
        ottomanSelector.click();
      }
    });
  });

document.querySelectorAll("[data-open-klaviyo-form]").forEach((el) => {
  el.addEventListener("click", () => {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(["openForm", el.dataset.openKlaviyoForm]);
  });
});

// Assembly Page
document.addEventListener("DOMContentLoaded", function () {
  const urlParams = new URLSearchParams(window.location.search);
  const product = urlParams.get("product"); // Get the product parameter from the URL

  if (product) {
    const dropdown = document.querySelector(
      ".assembly-category-dropdown__select"
    );
    const options = dropdown.options;
    let selectedOptionIndex = -1;

    // Loop through options to find the matching one
    for (let i = 0; i < options.length; i++) {
      if (options[i].text.toLowerCase().includes(product.replace("-", " "))) {
        selectedOptionIndex = i;
        dropdown.selectedIndex = i; // Select the dropdown option
        break;
      }
    }

    if (selectedOptionIndex !== -1) {
      const selectedOptionText = options[selectedOptionIndex].text;

      // Hide all product content by default
      const products = document.querySelectorAll(".assembly-product");
      products.forEach((product) => {
        product.style.display = "none";
      });

      // Show all product content that matches the selected option
      const selectedProducts = document.querySelectorAll(
        `.assembly-product[data-category="${selectedOptionText}"]`
      );
      selectedProducts.forEach((product) => {
        product.style.display = "flex";
      });

      // Hide all assembly instructions by default
      const instructions = document.querySelectorAll(".assembly-instructions");
      instructions.forEach((instruction) => {
        instruction.classList.add("assembly-instructions--hidden");
      });

      // Show the assembly instruction that matches the selected option
      const selectedInstruction = document.querySelector(
        `.assembly-instructions[data-category="${selectedOptionText}"]`
      );
      if (selectedInstruction) {
        selectedInstruction.classList.remove("assembly-instructions--hidden");
      }
    }
  }

});
  document.addEventListener("DOMContentLoaded", () => {
    const productSubmit = document.querySelector(".eva-product-submit-button"); // top button
    const stickyNav = document.querySelector(".page-navigation.eva-custom-product-container"); // sticky nav
    const bar = document.querySelector(".page-navigation");
    const isEclipse = bar.classList.contains("eva-custom-page-navigation");
    if(!isEclipse){
      if (productSubmit && stickyNav) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              // Product button is visible -> hide sticky
              stickyNav.classList.remove("active");
            } else {
              // Product button is out of view -> show sticky
              stickyNav.classList.add("active");
            }
          });
        }, { threshold: 0.1 });
  
        observer.observe(productSubmit);
      }
    }
});